import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { ApiError } from '../../services/api-error.model';
import { IssuerDto } from '../../services/dtos/issuer/issuer.dto';
import { fetchIssuer } from '../../services/issuers/issuers.service';
import { queryKeys } from '../queryKeyFactory';

export default (tag: string, options?: UseQueryOptions<IssuerDto, ApiError>): UseQueryResult<IssuerDto, ApiError> => {
  return useQuery<IssuerDto, ApiError>(queryKeys.fetchIssuers.single(tag), async () => fetchIssuer(tag), options);
};
